import React, { Component } from "react";
import RequestJSON from "../lib/requestJson";
import "./css/ResultMobile.css";
import Result from "./ResultMobile";
import { ReactSmartScroller } from "react-smart-scroller";

class ResultListFloorMobile extends Component {
  render() {
    return (
      <ReactSmartScroller spacing={5} draggable>
        <div className="list-result-mobile-main">
          {this.props.data
            .sort((a, b) => a.id - b.id)
            .map((result, index) =>
              result.imagelink !== "NoImage" ? (
                <Result
                  key={index}
                  result={result}
                  onSelect={this.props.onSelect}
                  current={this.props.current}
                />
              ) : null
            )}
        </div>
      </ReactSmartScroller>
    );
  }
}

export default RequestJSON(
  "https://www.shera.com/AR/api/?sqli=id,track,name,class,striped,color,size,width,numpersqm,imagelink,iconlink&table=floors"
)(ResultListFloorMobile);
